// import { AES, enc, pad } from 'crypto-js';

// // the key and iv should be 32 hex digits each, any hex digits you want, but it needs to be 32 on length each
// const secretKey = '0123456789abcdef0123456789abcdef';
// const secretIv = 'abcdef9876543210abcdef9876543210';
// const key = enc.Hex.parse(secretKey);
// const iv = enc.Hex.parse(secretIv);
// const padding = pad.ZeroPadding;

// export const aesEncrypt = dataString => AES.encrypt(dataString, key, { iv, padding }).toString();

// export const aesDecrypt = cipherString => AES.decrypt(cipherString, key, { iv, padding }).toString(enc.Utf8);

const crypto = require('crypto');
const ENCRYPTION_KEY = process.env.ENCRYPTION_KEY || "vkyp2s5v8y/B?E(H+MbQeThWmZq4t6w9"; // 32characters

export const aesEncrypt  = function encrypt(text) {
  const iv = crypto.randomBytes(16);
  const cipher = crypto.createCipheriv('aes-256-cbc', Buffer.from(ENCRYPTION_KEY), iv);
  let encrypted = cipher.update(text);
  encrypted = Buffer.concat([encrypted, cipher.final()]);
  return `${iv.toString('hex')}.${encrypted.toString('hex')}`;
}

export const aesDecrypt = function decrypt(text) {
  const [iv, encryptedText] = text.split('.');
  const decipher = crypto.createDecipheriv('aes-256-cbc', Buffer.from(ENCRYPTION_KEY), Buffer.from(iv, 'hex'));
  let decrypted = decipher.update(Buffer.from(encryptedText, 'hex'));
  decrypted = Buffer.concat([decrypted, decipher.final()]);
  return decrypted.toString('utf8');
}


